module.exports = __webpack_public_path__ + "img/result_wine_a.ee69bd71.png";